import {
  Entity,
  PhoneNumber,
  User,
  UserPhoneNumberType,
  UserRole,
  UserStatus,
} from '@gms/user-api';
import { TagColor } from 'shared/components/static-tag/tag-color.enum';
import { isNullOrUndefined } from 'shared/utils/type.utils';
import { IGridUser, IUserPermissions } from './users.models';

const userColorMap = {
  [UserStatus.Active]: TagColor.GREEN,
  [UserStatus.Inactive]: TagColor.RED,
  [UserStatus.Terminated]: TagColor.BLUE,
};

//TODO: Need to get phone number types from store here.
const userPhoneOrder = {
  ['Office']: 0,
  ['Cell']: 1,
  ['24 Hour']: 2,
  ['Main Office']: 3,
  ['Fax']: 4,
  ['Gas Control']: 5,
};

const addPermissionsToUserPermissions = (
  rows: Map<string, IUserPermissions>,
  currentPermission: UserRole,
  desiredProperty: string
) => {
  if (rows.has(currentPermission.name)) {
    const currentUserPermissions = rows.get(currentPermission.name);
    currentUserPermissions.permissionsByColumn[currentPermission.tspId] = {
      ...currentUserPermissions.permissionsByColumn[currentPermission.tspId],
      [desiredProperty]: currentPermission[desiredProperty],
    };
  } else {
    const newUserPermissions = {
      id: currentPermission.userRoleId,
      name: currentPermission.name,
      permissionsByColumn: {
        [currentPermission.tspId]: { [desiredProperty]: currentPermission[desiredProperty] },
      },
    };
    newUserPermissions.permissionsByColumn[currentPermission.tspId] = {
      [desiredProperty]: currentPermission[desiredProperty],
    };
    rows.set(currentPermission.name, newUserPermissions);
  }
  return rows;
};

export const userUtils = {
  mapUsersToGridUser: (user: User) => {
    const gridUser = { ...user } as IGridUser;

    gridUser.statusColor = userColorMap[user.userStatus];
    gridUser.entities = gridUser.entities
      ? [...gridUser.entities].sort((a: Entity, b: Entity) => a.name.localeCompare(b.name))
      : [];
    gridUser.phoneNumbers = gridUser.phoneNumbers
      ? [...gridUser.phoneNumbers].sort(
          (a: PhoneNumber, b: PhoneNumber) =>
            userPhoneOrder[a.phoneNumberType] - userPhoneOrder[b.phoneNumberType]
        )
      : [];

    return gridUser;
  },
  getUserDefaultPhoneNumber: (phoneNumbers: Array<PhoneNumber>) => {
    return phoneNumbers ? phoneNumbers.find(phoneNumber => phoneNumber.isDefault === true) : null;
  },

  getUserMFACellPhoneNumber: (phoneNumbers: Array<PhoneNumber>) => {
    return phoneNumbers ? phoneNumbers.find(phoneNumber => phoneNumber.isMFA) : null;
  },

  mapUserAndTspsToPermissions: (user: IGridUser): Array<IUserPermissions> => {
    if (!user || !user.userRoles) {
      return [];
    }
    let permissions = new Map<string, IUserPermissions>();

    permissions = user.userRoles.reduce(
      (rows, currentPermissions) =>
        addPermissionsToUserPermissions(rows, currentPermissions, 'permissionOptionId'),
      permissions
    );
    permissions = user.userRoles.reduce(
      (rows, currentPermissions) =>
        addPermissionsToUserPermissions(rows, currentPermissions, 'contactLevelId'),
      permissions
    );

    return Array.from(permissions.values()).sort((a: IUserPermissions, b: IUserPermissions) =>
      a.name.localeCompare(b.name)
    );
  },

  getUserName(user: User): string {
    return !isNullOrUndefined(user) ? `${user.firstName} ${user.lastName}`.trim() : null;
  },
};
